import { useQuery, useSubscription } from "@apollo/react-hooks";
import { MY_TIME_GET_WORK_TIME } from "my-time/graphql/queries";
import { MY_TIME_REQUESTS_SUBSCRIPTION } from "my-time/graphql/subscriptions";

interface UseMyTimeWorkTimeParams {
  contractCode: string;
  startTime: string;
  endTime: string;
  myTimeType: string;
}

export const useMyTimeWorkTime = ({
  contractCode,
  startTime,
  endTime,
  myTimeType,
}: UseMyTimeWorkTimeParams) => {
  const { data, loading, error, refetch} = useQuery(MY_TIME_GET_WORK_TIME, {
    fetchPolicy: "cache-and-network",
    skip: !contractCode || !startTime || !endTime || !myTimeType,
    variables: {
      contractCode,
      startTime,
      endTime,
      myTimeType,
    },
  });

  useSubscription(MY_TIME_REQUESTS_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    skip: !contractCode || !startTime || !endTime || !myTimeType,
    onData: () => {
      refetch();
    },
  });

  return {
    data: data?.getWorkTime || [],
    loading,
    error,
  };
};

export default useMyTimeWorkTime;
